module.exports = __webpack_public_path__ + "static/media/BBCReithSans_W_Lt.cb9d8316.woff";